import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import DatePickerComponente from '../../../../LaridaeApp/datepicker/container/DatePickerComponente'

import { actualizarDatosParaMuiTable } from '../actions/TablaCamionesVolcadosActions'
import { TablaCamionesVolcadosView } from '../components/TablaCamionesVolcadosView'

const TablaCamionesVolcados = (props) => {
  useEffect(() => props.actualizarDatosParaMuiTable(new Date()), [props])
  return (
    <>
      <DatePickerComponente
        onDateChange={props.actualizarDatosParaMuiTable}
      />
      <hr />
      <TablaCamionesVolcadosView />
    </>
  )
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaCamionesVolcados)
